import Swiper from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import { defineComponent } from "@/js/utils/alpine";

export default defineComponent(() => ({
    swiperInstance: undefined as Swiper | undefined,
    init() {
        const swiperEl = this.$refs.swiper as HTMLElement;

        this.swiperInstance = new Swiper(swiperEl, {
            modules: [A11y, Navigation],
            slidesPerView: 2.6, 
            spaceBetween: 20, 
            autoHeight: false, 
            navigation: {
                nextEl: '.featured-products-slider__control-next',
                prevEl: '.featured-products-slider__control-prev',
            },
            breakpoints: {
                1440:{
                    slidesPerView: 2.6,
                },
                1280: {
                    slidesPerView: 2.3,
                },
                1100: {
                    slidesPerView: 2.1,
                },
                990: {
                    slidesPerView: 1.9,
                },
                480: {
                    slidesPerView: 1.5,
                },
                320: {
                    slidesPerView: 1.2,
                }
            }
        });
    }
}));
